import Storage, {StorageChange, StorageItems, StorageKeys} from "./index.js";

/**
 * Implements local storage for MV2 extensions. Both background scripts and content
 * scripts can access the storage API.
 *
 * @deprecated
 */
export default class Mv2ExtLocalStorage extends Storage {
	get(keys: StorageKeys | StorageItems): Promise<StorageItems> {
		return new Promise((resolve, reject) => {
			chrome.storage.local.get(keys, items => {
				if (items)
					resolve(items);
				else
					reject();
			});
		});
	}

	set(items: StorageItems) {
		return new Promise<void>((resolve, reject) => {
			chrome.storage.local.set(items, () => {
				if (chrome.runtime.lastError)
					reject(chrome.runtime.lastError);
				else
					resolve();
			});
		});
	}

	remove(keys: StorageKeys) {
		return new Promise<void>((resolve, reject) => {
			chrome.storage.local.remove(keys ?? [], () => {
				if (chrome.runtime.lastError)
					reject(chrome.runtime.lastError);
				else
					resolve();
			});
		});
	}

	clear() {
		return new Promise<void>((resolve, reject) => {
			chrome.storage.local.clear(() => {
				if (chrome.runtime.lastError)
					reject(chrome.runtime.lastError);
				else
					resolve();
			});
		});
	}

	listen(callback: (changes: StorageChange) => void) {
		chrome.storage.onChanged.addListener((changes, namespace) => {
			if (namespace !== "local")
				return;

			callback(changes);
		});
	}
}
